var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAeldari = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 643.906,
  height: 800,
  viewBox: "0 0 170.367 211.667"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h408.857v440.227H0Z"
})))), /*#__PURE__*/React.createElement("path", {
  d: "m148.623 177.783-43.697 75.684-40.35-2.695v20.397l30.814-1.185-31.951 55.34h29.079l-12.97 18.21 17.987 10.368 13.687-28.577h28.936v64.125h16.928v-64.125h28.936l13.688 28.577 17.985-10.368-12.969-18.21h29.08l-31.952-55.34 30.814 1.185v-20.397l-40.35 2.695zm0 30.975 20.818 36.059a41.594 24.837 0 0 0-20.818-3.37 41.594 24.837 0 0 0-20.813 3.358zm12.675 42.933a30.816 17.328 0 0 1 18.14 15.776 30.816 17.328 0 0 1-30.815 17.329 30.816 17.328 0 0 1-30.818-17.329 30.816 17.328 0 0 1 18.125-15.765 13.8 13.8 0 0 0-1.061 5.29 13.754 13.754 0 0 0 13.754 13.755 13.754 13.754 0 0 0 13.752-13.754 13.8 13.8 0 0 0-1.077-5.302m-51.236 23.855a41.594 24.837 0 0 0 8.561 7.893l-7.124 15.238-4.914 6.898h-13.86Zm77.125.007 17.332 30.022h-13.86l-4.914-6.898-7.115-15.22a41.594 24.837 0 0 0 8.557-7.904m-55.909 13.263a41.594 24.837 0 0 0 8.88 1.74v15.019h-19.476l.973-2.032zm34.691.007 9.619 14.72.973 2.033h-19.475v-14.997a41.594 24.837 0 0 0 8.883-1.756",
  style: {
    opacity: 1,
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.35282427,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 0.45116278,
    paintOrder: "normal"
  },
  transform: "translate(-63.439 -177.783)"
}));
export default SvgAeldari;